import { render, staticRenderFns } from "./FeedbackTicketsTable.vue?vue&type=template&id=3e1e8714&"
import script from "./FeedbackTicketsTable.vue?vue&type=script&lang=ts&"
export * from "./FeedbackTicketsTable.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackTicketsTable.vue?vue&type=style&index=0&id=3e1e8714&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports